<template>
  <validation-observer ref="validationObserver" v-slot="{ handleSubmit }">
    <b-modal
      v-model="modalAberto"
      title="Adicionar novo nº da conta bancária"
      header-bg-variant="secondary"
      header-text-variant="light"
      @hide="closeModal"
      centered
    >
      <b-form @submit.prevent="handleSubmit(adicionar)">
        <b-container>
          <b-row>
            <b-col v-if="copiaConta" cols="12">
              <default-form-validation-provider
                label="Código do Banco:"
                rules=""
              >
                <b-form-input
                  v-model="copiaConta.CodigoBanco"
                  disabled
                  class="mb-2"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col v-if="copiaConta" cols="12">
              <default-form-validation-provider
                label="Código da Agência:"
                rules=""
              >
                <b-form-input
                  v-model="copiaConta.CodigoAgencia"
                  disabled
                  class="mb-2"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col v-if="copiaConta" cols="12">
              <default-form-validation-provider
                label="Nº Atual da Conta Bancária:"
                rules=""
              >
                <b-form-input
                  v-model="copiaConta.NumeroContBancaria"
                  disabled
                  class="mb-2"
                />
              </default-form-validation-provider>
            </b-col>
            <b-col cols="12">
              <default-form-validation-provider
                label="Nº Novo da Conta Bancária:"
              >
                <b-form-input
                  v-model="conta.NumeroContBancariaNovo"
                  class="mb-2"
                  placeholder="Apenas números"
                  maxlength="15"
                />
              </default-form-validation-provider>
            </b-col>
          </b-row>
        </b-container>
      </b-form>
      <template #modal-footer>
        <b-button size="sm" variant="outline-secondary" @click="closeModal"
          >Cancelar</b-button
        >
        <b-button
          size="sm"
          variant="secondary"
          type="submit"
          @click="handleSubmit(adicionar)"
          :disabled="!conta.NumeroContBancariaNovo"
        >
          Salvar
        </b-button>
      </template>
    </b-modal>
  </validation-observer>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { ValidationObserver } from "vee-validate";
import { Component, Vue, Prop } from "vue-property-decorator";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { ContaCaixa } from "@/types/entregas/pcm/conta-caixa";
import pcmService from "@/services/entregas/pcmService";
import { ContaCaixaResumida } from "@/types/entregas/pcm/conta-caixa-resumida";

@Component({
  components: {
    ValidationObserver,
    DefaultFormValidationProvider,
  },
})
export default class ModalNovoNumero extends mixins(UtilsTS, Vue) {
  @Prop({ required: true }) conta!: ContaCaixa;

  modalAberto = true;
  copiaConta: ContaCaixa | null = null;

  async mounted() {
    this.copiaConta = this.conta;
  }

  async adicionar() {
    try {
      if (this.conta.NumeroContBancariaNovo) {
        this.conta.NumeroContBancariaNovo = this.apenasNumeros(
          this.conta.NumeroContBancariaNovo
        );
      }
      if (
        (this.conta.NumeroContBancariaNovo &&
          this.conta.NumeroContBancariaNovo.length > 15) ||
        this.conta.NumeroContBancariaNovo == null
      ) {
        this.$toast.error(
          "O nº da conta deve conter até 15 dígitos e apenas números."
        );
        return;
      }
      const contaResumida = new ContaCaixaResumida(this.conta);
      const response = await pcmService.atualizarContaCaixa(contaResumida);
      if (response)
        this.$toast.success(
          `Nº da conta atualizada para ${contaResumida.nroContaNovo}`
        );
      this.closeModal();
    } catch (error: any) {
      this.tratarError(error);
      console.error("Erro ao atualizar", error);
    }
  }

  closeModal() {
    this.$emit("close");
  }
}
</script>